import { Link } from "react-router-dom"
import './header.css'


function MenuMobile({myclass}){
  return(
    
   <div className="menu-mobile ">
 
    <Link className="" to="/">Início</Link>
    <Link className="" to="/info">Info</Link>
    <Link className="" to="/contact">Contacto</Link>
    </div>
    
     
  )
}
export default MenuMobile;